module.exports = __webpack_public_path__ + "media/src/assets/img/logo/parking_logo-c185dd5ff7c397da2ce64b1981b84c2e.png";